// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_POLICY_GET_REQUEST = "NETWORK_POLICY_GET_REQUEST";
export const NETWORK_POLICY_GET_REQUEST_SUCCESS =
  "NETWORK_POLICY_GET_REQUEST_SUCCESS";
export const NETWORK_POLICY_GET_REQUEST_FAILURE =
  "NETWORK_POLICY_GET_REQUEST_FAILURE";
export const NETWORK_POLICY_GET_RESET = "NETWORK_POLICY_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(id, resolve, reject) {
  return {
    type: NETWORK_POLICY_GET_REQUEST,
    id,
    resolve,
    reject,
  };
}

export function requestSuccess(data, id) {
  return {
    type: NETWORK_POLICY_GET_REQUEST_SUCCESS,
    data,
    id,
  };
}

export function requestFailure(error, id) {
  return {
    type: NETWORK_POLICY_GET_REQUEST_FAILURE,
    error,
    id,
  };
}

export function reset() {
  return {
    type: NETWORK_POLICY_GET_RESET,
  };
}
